import axios, { baseUrl, utilityBaseUrl } from './axios';
import queryString from 'query-string';

export default {
  sendVerificationCode: async options => {
    const result = await axios.post(
      `${baseUrl}/customer/mob/organisations/${
        options.organisationId
      }/po/patient/send_codes`,
      options,
    );
    return result.data;
  },
  getUploadData: async options => {
    const result = await axios.post(
      `${utilityBaseUrl}file/customer/patient/signatures?Authorization=${
        options.token
      }`,
      options,
    );
    return result.data;
  },

  uploadSignature: async options => {
    const result = await axios.put(options.rawUrl, options.data, {
      transformRequest: [
        (data, headers) => {
          delete headers.common.Authorization;
          return data;
        },
      ],
    });
    return result.data;
  },

  verifyCode: async options => {
    const result = await axios.get(
      `${baseUrl}/customer/mob/organisations/${
        options.organisationId
      }/po/patient/check_codes/${options.verificationCode}`,
    );
    return result.data;
  },
  getOnsiteBookingSlot: async options => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.post(
      `${baseUrl}/scheduler/mob/organisations/${
        options.organisationId
      }/po/booking_slots${params ? `?${params}` : ''}`,
      {},
    );
    return result.data;
  },
  checkValidPOToken: async options => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.post(
      `${baseUrl}/account/pub/token/valid_po_tokens${
        params ? `?${params}` : ''
      }`,
      options,
    );
    return result.data;
  },
};
